const menuArray = [
  {
    id: 'validation',
    index: 0,
    parent: null,
    url: '/cart/consultancy',
    children: [
      {
        id: 'menuContract',
        index: 1,
        url: '/contract',
        children: [],
        icon: 'description',
      },
      {
        id: 'validate',
        index: 0,
        url: '/validate',
        children: [],
        country: 'MX',
        icon: 'verified',
      },
      {
        id: 'documents',
        index: 1,
        url: '/documents',
        children: [],
        country: 'MX',
        icon: 'upload_file',
      },
      // {
      //   id: 'attentions',
      //   index: 1,
      //   external: true,
      //   url: 'https://atenciones.terramarbrands.com.mx/',
      //   children: [],
      // },
    ],
  },
  {
    id: 'awards',
    index: 0,
    parent: null,
    url: '/cart/consultancy/awards',
    children: [],
  },
  {
    id: 'terravoucher',
    index: 0,
    parent: null,
    url: '/cart/consultancy/terravoucher',
    children: [],
    country: 'MX',
  },
  {
    id: 'lineage',
    index: 0,
    parent: null,
    url: '/cart/consultancy',
    children: [
      {
        id: 'lineagestatus',
        index: 0,
        url: '/lineagestatus',
        children: [],
        icon: 'trending_up',
      },
      {
        id: 'accountstatus',
        index: 0,
        url: '/accountstatus',
        children: [],
        icon: 'receipt_long',
      },
      {
        id: 'branch',
        index: 0,
        url: '/branch',
        children: [],
        icon: 'account_tree',
      },
      {
        id: 'simulator',
        index: 0,
        url: '/simulator',
        children: [],
        icon: 'assessment',
      },
      {
        id: 'petition',
        index: 0,
        url: '/petition',
        children: [],
        icon: 'query_stats',
      },
    ],
  },
  {
    id: 'attentions',
    index: 0,
    parent: null,
    url: '/cart/consultancy/attentions',
    children: [
      {
        id: 'myAttentions',
        index: 0,
        url: '/myAttentions',
        children: [],
        icon: 'format_list_numbered_rtl',
      },
      {
        id: 'newAttention',
        index: 1,
        url: '/newAttention',
        children: [],
        icon: 'add',
      },
    ],
  },
  {
    id: 'basesandevents',
    index: 0,
    parent: null,
    url: '/cart/consultancy',
    children: [
      {
        id: 'travel',
        index: 0,
        url: '/travel',
        children: [],
        icon: 'flight',
      },
      {
        id: 'nationaltravel',
        index: 0,
        url: '/nationaltravel',
        children: [],
        icon: 'flight',
      },
      {
        id: 'calendar',
        index: 1,
        url: '/calendar',
        children: [],
        icon: 'calendar_month',
      },
      {
        id: 'wheel',
        index: 2,
        url: '/wheel',
        children: [],
        icon: 'directions_car',
      },
      {
        id: 'growingTogether',
        index: 3,
        url: '/growingTogether',
        children: [],
        icon: 'signal_cellular_alt',
      },
    ],
  },
  {
    id: 'shipments',
    index: 0,
    parent: null,
    url: '/cart/consultancy/shipments',
    children: [],
    mobile: 'true',
  },
];

export default menuArray;
